<div class="box">
  <div class="header">
    <div class="content" [ngClass]="'primary'">{{ 'PERFILES' }}</div>
  </div>

  <div class="content-card"  [formGroup]="form">
    <mat-dialog-content class="dialog-body">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>NOMBRE</mat-label>
        <input matInput formControlName="name" maxlength="37"/>
      </mat-form-field>
    </mat-dialog-content>

    <div class="btn-actions">
      <button mat-button class="btn-cancelar" (click)="cancel()">{{'CANCELAR'}}</button>&nbsp;&nbsp;
      <button mat-button class="btn-generar" (click)="accept()" [disabled]="form.invalid">{{'ACEPTAR'}}</button>
    </div>
  </div>
</div>
